import React from 'react';
import {Await, useLoaderData, useMatches} from '@remix-run/react';
import {Suspense} from 'react';

//components
import ProductsMarquee from 'components/modules/ProductsMarquee';

//types
import type {SanityModuleSelectedProducts} from 'domains/modules';
import type {I18nLocale} from '~/lib/type';

import {loader} from '~/routes/($lang)/index';

interface Props {
  module: SanityModuleSelectedProducts;
}

const SelectedProducts: React.FC<Props> = ({module}) => {
  const {featuredProducts} = useLoaderData<typeof loader>();
  const [root] = useMatches();
  const selectedLocale = root?.data?.selectedLocale as I18nLocale | undefined;
  const isZh = selectedLocale?.language !== 'EN';

  if (featuredProducts) {
    return (
      <Suspense fallback="loading">
        <Await resolve={featuredProducts}>
          {(products) => {
            if (!products) return <></>;
            return (
              <ProductsMarquee
                // Curated homepage picks — labelled 店長推薦 (was 新到產品);
                // the real newest-listed products live in the NewArrivals
                // section rendered right below this one.
                title={isZh ? '店長推薦' : 'Staff Picks'}
                products={products}
                className="!pb-2"
              />
            );
          }}
        </Await>
      </Suspense>
    );
  }
  return <></>;
};

export default SelectedProducts;
